module.exports = __webpack_public_path__ + "assets/img/paypal.a9bfde59.svg";